module.exports = __webpack_public_path__ + "img/knight.b9abf85b.svg";